import superagentInterface from 'redux-query-interface-superagent';

/**
 * Custom network adapter that wraps superagent interface
 * to ensure response headers are accessible in transform functions
 */
const customSuperagentInterface = (
  url: string,
  method: string,
  config: any
) => {
  const networkInterface = superagentInterface(url, method, config);

  return {
    abort: networkInterface.abort,
    execute: (
      callback: (
        err: any,
        status: number,
        body: any,
        text: any,
        headers: any
      ) => void
    ) => {
      networkInterface.execute((err, status, body, text, headers) => {
        let modifiedBody = body;

        // Attach headers to the response body ONLY for object responses
        // to ensure backward compatibility with arrays and primitives
        // This wil be redisigned when upgrading infrastructure of the app
        if (
          headers &&
          body &&
          typeof body === 'object' &&
          !Array.isArray(body)
        ) {
          modifiedBody = {
            ...body,
            headers,
          };
        }

        callback(err, status, modifiedBody, text || '', headers);
      });
    },
  };
};

export default customSuperagentInterface;
